import type { RewardType } from './enums';

export const REWARD_TYPE_ICONS: Record<RewardType | string, string> = {
  discount: '🏷️',
  voucher: '🎫',
  benefit: '🎁',
  team_event: '🤝',
};
